module.exports = __webpack_public_path__ + "static/img/kan.e6b1fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/kan.png
// module id = Asms
// module chunks = 66